// extracted by css-extract-rspack-plugin
export default {"navigationLink":"navigationLink-Qm2Xxb"};